import { Box, Tab, Tabs, Typography, useTheme } from "@mui/material";
import React from "react";
import Profile from "./Profile";
import Organization from "./Organization";
import Subscription from "./Subscription";


interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
  }
  
  function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box 
            sx={{ 
              p: 3,
              backgroundColor: isDarkMode ? '#1e1e1e' : '#ffffff',
              color: isDarkMode ? '#ffffff' : '#000000'
            }}
          >
            {children}
          </Box>
        )}
      </div>
    );
  }
  
  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }
  

const Accounts = () => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [value, setValue] = React.useState(0);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
      setValue(newValue);
    };
  return (
    <>
      <Box 
        sx={{ 
          width: "100%",
          borderBottom: 1, 
          borderColor: isDarkMode ? 'rgba(255, 255, 255, 0.12)' : 'divider',
          backgroundColor: isDarkMode ? '#1e1e1e' : '#ffffff'
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          sx={{
            '& .MuiTab-root': {
              color: isDarkMode ? '#ffffff' : '#000000',
              '&.Mui-selected': {
                color: isDarkMode ? '#ffffff' : '#000000',
              },
            },
            '& .MuiTabs-indicator': {
              backgroundColor: isDarkMode ? '#ffffff' : '#000000',
            },
          }}
        >
          <Tab 
            label={
              <Typography 
                variant="body2" 
                sx={{
                  fontWeight: "bold",
                  fontSize: "13px",
                  color: isDarkMode ? '#ffffff' : '#000000'
                }}
              >
                Profile
              </Typography>
            } 
            {...a11yProps(0)} 
          />
          <Tab 
            label={
              <Typography 
                variant="body2" 
                sx={{
                  fontWeight: "bold",
                  fontSize: "13px",
                  color: isDarkMode ? '#ffffff' : '#000000'
                }}
              >
                Organization
              </Typography>
            }
            {...a11yProps(1)} 
          />
          {/* <Tab 
            label={
              <Typography 
                variant="body2" 
                sx={{
                  fontWeight: "bold",
                  fontSize: "13px",
                  color: isDarkMode ? '#ffffff' : '#000000'
                }}
              >
                Subscription
              </Typography>
            }
            {...a11yProps(2)} 
          /> */}
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <Profile/>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <Organization/>
      </CustomTabPanel>
      {/* <CustomTabPanel value={value} index={2}>
        <Subscription/>
      </CustomTabPanel> */}
    </>
  );
};

export default Accounts;
